exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search{width:200px;margin-right:10px}\n", ""]);

// exports
